export type IdentifyOperation = {
  op: "update_or_create"
  key: string
  value: unknown
}

export const createIdentifyOperation = (key: string, value: unknown): IdentifyOperation => ({
  op: "update_or_create",
  key,
  value,
})
